import axiosInstance from "../utils/axios";

export const getDashboardInfo = async () => {
  try {
    const res = await axiosInstance.get("api/dashboard/publisher", {
      withCredentials: true,
    });
    if (res?.data?.publisherSubscriptionInfo) {
      window.sessionStorage.setItem(
        "publisherSubscriptionInfo",
        JSON.stringify(res?.data?.publisherSubscriptionInfo)
      );
      window.sessionStorage.setItem(
        "displayFulfillmentProducts",
        JSON.stringify(res?.data?.displayFulfillmentProducts)
      );
    }
    if (res?.data?.lastFulfillmentRun) {
      window.sessionStorage.setItem(
        "lastFulfillmentRun",
        JSON.stringify(res?.data?.lastFulfillmentRun)
      );
    }
    if (res?.data?.helpMap) {
      window.sessionStorage.setItem(
        "helpMap",
        JSON.stringify(res?.data?.helpMap)
      );
    }
    return res.data;
  } catch (error) {
    return error;
  }
};
